
import React from 'react'
// import styled from 'styled-components'

// import { FixedSpaceColumn } from 'lib-components/layout/flex-helpers'
import type { CitizenCustomizations} from 'lib-customizations/types'

import { citizenConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'
import mapConfig from './mapConfig'
import { H1, H2, H3, P } from 'lib-components/typography'
import ExternalLink from 'lib-components/atoms/ExternalLink'
import colors from 'lib-customizations/common'

// const MultiLineCheckboxLabel = styled(FixedSpaceColumn).attrs({
//   spacing: 'zero'
// })`
//   margin-top: -6px;
// `

const customizations: CitizenCustomizations = {
  appConfig: citizenConfig,
  langs: ['fi', 'sv', 'en'],
  translations: {
    fi: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© Paltamon kunta',
        privacyPolicyLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/tietosuoja.html"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Tietosuojaselosteet
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Lähetä palautetta
          </a>
        ),
      },
      loginPage: {
        title: 'Paltamon kunnan varhaiskasvatus',
        login: {
          infoBoxText: (
            <>
            <P>
              Mikäli kirjautuminen tästä ei onnistu, ole yhteydessä varhaiskasvatuspäällikköön.
          </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "Tässä näkymässä voit hakea kartalta Paltamon varhaiskasvatus-, esiopetuspaikkoja.",
        serviceVoucherLink:
          'https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html',
      },
      applications: {
        creation: {
          preschoolInfo: (
            <>
              <P>
                Maksutonta esiopetusta on neljä tuntia päivässä. Tämän lisäksi lapselle voidaan hakea täydentävää varhaiskasvatusta, jota tarjotaan aamulla
                ennen esiopetuksen alkua ja iltapäivisin esiopetuksen jälkeen. Hakemuksen täydentävään varhaiskasvatukseen voi tehdä esiopetukseen
                ilmoittautumisen yhteydessä tai erillisenä hakemuksena opetuksen jo alettua. {' '}
                <a href='https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html'>
                  https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html</a>
              </P>
            </>
          ) as unknown as string,
          transferApplicationInfo: {
            DAYCARE:
              'Lapsella on jo paikka Paltamon varhaiskasvatuksessa. Tällä hakemuksella voit hakea siirtoa toiseen varhaiskasvatusta tarjoavaan yksikköön Paltamossa.',
          },
          applicationInfo: (
            <P>
             Hakemukseen voi tehdä muutoksia niin kauan kuin hakemusta ei ole otettu käsittelyyn.
             Tämän jälkeen muutokset hakemukseen tehdään ottamalla yhteyttä varhaiskasvatuspäällikköön (puh.040 750 5607 ).
             Voit perua jo tehdyn hakemuksen ilmoittamalla siitä sähköpostilla anna.sivonen@paltamo.fi
            </P>
          )
        },
        editor: {
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    Varhaiskasvatusta voi hakea ympäri vuoden. Hakemus on jätettävä
                    viimeistään neljä kuukautta ennen kuin tarvitsette paikan.
                    Mikäli tarvitsette varhaiskasvatusta kiireellisesti työn tai
                    opiskelujen vuoksi, tulee paikkaa hakea viimeistään kaksi
                    viikkoa ennen.
                  </P>
                  <P>
                    Saatte kirjallisen päätöksen varhaiskasvatuspaikasta{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P>
                    Kunnallisen varhaiskasvatuksen asiakasmaksut ja palvelusetelin
                    omavastuuosuus määräytyvät prosenttiosuutena perheen
                    bruttotuloista. Tulojen lisäksi maksuihin vaikuttaa perheen koko
                    ja sovittu varhaiskasvatusaika. Palveluseteliyksiköissä voidaan
                    periä lisämaksu, tiedot mahdollisesta lisämaksusta löytyy
                    yksikön nettisivuilta. Perhe toimittaa tuloselvityksen
                    bruttotuloistaan viimeistään kahden viikon kuluessa siitä, kun
                    lapsi on aloittanut varhaiskasvatuksessa.
                  </P>
                  <P>
                    Paltamon kunnassa on maksuton varhaiskasvatus. Lisätietoa löydät täältä:{' '}
                    <a href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html">
                      Maksut varhaiskasvatuksessa
                    </a>
                    {' '}
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Esiopetukseen osallistutaan oppivelvollisuuden alkamista edeltävänä vuonna. Esiopetus on maksutonta.
                  Jos tarvitsette varhaiskasvatusta ennen esiopetuksen alkua, voitte hakea sitä tällä hakemuksella valitsemalla
                  ”Haen myös esiopetusta täydentävää varhaiskasvatusta”. Lisätietoja:{' '}
                  <a href='https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html'>https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html</a>
                  </P>
                  <P>
                    Päätökset tulevat{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              CLUB: (
                <>
                  <P>
                    Hakuaika syksyllä käynnistyvään apip-toimintaan on maaliskuussa. Kun lapsenne saa apip-paikan,
                    saatte päätöksen siitä huhti-toukokuun aikana.
                  </P>
                  <P>
                    Päätös tehdään yhden toimintakauden ajaksi (elokuusta toukokuun loppuun).
                  </P>
                  <P>
                    Päätös apip-paikasta tulee Suomi.fi-palveluun tai postitse, mikäli ette ole ottanut palvelua käyttöön.
                    Apip-hakemuksen voi jättää myös hakuajan ulkopuolella ja sen jälkeen, kun koulun lukuvuosi on jo alkanut.
                    Apip-toiminta on maksullista.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              )
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                Ymmärrän, että tieto hakemuksesta menee myös lapsen toiselle
                huoltajalle. Jos tieto ei saa mennä toiselle huoltajalle, ole
                yhteydessä varhaiskasvatuspäällikköön (puh. 040 750 5607) tai sähköpostilla anna.sivonen@paltamo.fi.
              </span>
            ),
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                  'https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html'
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    Mikäli varhaiskasvatuspaikan tarve johtuu äkillisestä
                    työllistymisestä tai opiskelusta, tulee paikkaa hakea
                    viimeistään <strong>kaksi viikkoa ennen</strong> kuin tarve
                    alkaa. Hakemuksen{' '}
                    <strong>liitteenä tulee olla työ- tai opiskelutodistus</strong>{' '}
                    molemmilta samassa taloudessa asuvilta huoltajilta.
                    Suosittelemme toimittamaan liitteen sähköisesti tässä, sillä
                    kahden viikon käsittelyaika alkaa siitä, kun olemme
                    vastaanottaneet hakemuksen tarvittavine liitteineen. Jos et voi
                    lisätä liitteitä hakemukselle sähköisesti, lähetä ne postilla
                    osoitteeseen Varhaiskasvatus, Salmelankuja 1, 88300 Paltamo
                  </P>
                ),
              }
            },
            dailyTime: {
              instructions: {
                DAYCARE:
                  'Ilmoita lapsen yleisimmin tarvitseva varhaiskasvatusaika, aika tarkennetaan varhaiskasvatuksen alkaessa.',
                PRESCHOOL:
                  'Esiopetusta tarjotaan 4 tuntia päivässä, Kontiomäessä klo 8-12 ja kirkonkylällä klo 8.45-12.45. Ilmoita lapsen tarvitsema varhaiskasvatusaika siten, että se sisältää esiopetusajan 4 h (esim. 7.00 – 17.00). Aika tarkennetaan varhaiskasvatuksen alkaessa. Varhaiskasvatustarpeen ajan vaihdellessa päivittäin tai viikoittain (esim. vuorohoidossa), ilmoita tarve tarkemmin lisätiedoissa lomakkeen lopussa.'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    Voit hakea lapselle tarvittaessa{' '}
                    <strong>
                      esiopetukseen lisäksi liittyvää varhaiskasvatusta, joka on maksutonta.
                    </strong>{' '}
                    Liittyvää varhaiskasvatusta järjestetään aamuisin ennen esiopetusta ja esiopetuksen jälkeen esiopetusyksikön aukioloaikojen mukaisesti.
                  </P>
                  <P>
                    Saat varhaiskasvatuspaikasta erillisen kirjallisen päätöksen.
                    Päätös tulee{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi-viestit
                    -palvelua käyttöön.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                Lisätietoa varhaiskasvatuksen maksuista, palvelusetelin lisämaksusta
                ja tuloselvityslomakkeen löydät täältä, Paltamossa maksutonta:
                <br />
                <a
                  href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maksut varhaiskasvatuksessa
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Paltamon varhaiskasvatuksessa virallisena osoitteena pidetään väestötiedoista saatavaa osoitetta. Osoite väestötiedoissa muuttuu hakijan tehdessä muuttoilmoituksen postiin tai maistraattiin.",
          },
        },
      },
      decisions: {
        assistancePreschoolDecisions: {
          appealInstructions: (
            <>
              <P>
                Tähän päätökseen tyytymätön voi tehdä kirjallisen
                oikaisuvaatimuksen. Päätökseen ei saa hakea muutosta valittamalla
                tuomioistuimeen.
              </P>

              <H3>Oikaisuvaatimusoikeus</H3>
              <P>
                Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai
                jonka oikeuteen, velvollisuuteen tai etuun päätös välittömästi
                vaikuttaa (asianosainen).
              </P>

              <H3>Oikaisuvaatimusaika</H3>
              <P>
                Oikaisuvaatimus on tehtävä 14 päivän kuluessa päätöksen
                tiedoksisaannista.
              </P>
              <P>
                Oikaisuvaatimus on toimitettava Pohjois-Suomen aluehallintovirastolle
                viimeistään määräajan viimeisenä päivänä ennen Pohjois-Suomen
                aluehallintoviraston aukioloajan päättymistä.
              </P>
              <P>
                Asianosaisen katsotaan saaneen päätöksestä tiedon, jollei muuta
                näytetä, seitsemän päivän kuluttua kirjeen lähettämisestä tai
                saantitodistukseen tai tiedoksiantotodistukseen merkittynä päivänä.
              </P>
              <P>
                Käytettäessä tavallista sähköistä tiedoksiantoa asianosaisen
                katsotaan saaneen päätöksestä tiedon, jollei muuta näytetä,
                kolmantena päivänä viestin lähettämisestä.
              </P>
              <P>
                Tiedoksisaantipäivää ei lueta oikaisuvaatimusaikaan. Jos
                oikaisuvaatimusajan viimeinen päivä on pyhäpäivä, itsenäisyyspäivä,
                vapunpäivä, joulu- tai juhannusaatto tai arkilauantai, saa
                oikaisuvaatimuksen tehdä ensimmäisenä arkipäivänä sen jälkeen.
              </P>

              <H3>Oikaisuviranomainen</H3>
              <P>
                Viranomainen, jolle oikaisuvaatimus tehdään, on Pohjois-Suomen
                aluehallintovirasto
              </P>
              <P>
                https://www.suomi.fi/palvelut/verkkoasiointi/oikaisuvaatimus-varhaiskasvatus-opetus-ja-koulutus-aluehallintovirasto/d7022cad-9ecd-4dad-84ec-17489d260a8d
              </P>
              <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
              <P>
                Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja
                täyttää vaatimuksen kirjallisesta muodosta.
              </P>
              <P noMargin>Oikaisuvaatimuksessa on ilmoitettava</P>
              <ul>
                <li>päätös, johon vaaditaan oikaisua,</li>
                <li>millaista oikaisua päätökseen vaaditaan,</li>
                <li>millä perusteilla oikaisua vaaditaan</li>
              </ul>
              <P>
                Oikaisuvaatimuksessa on lisäksi ilmoitettava tekijän nimi,
                kotikunta, postiosoite, puhelinnumero ja muut asian hoitamiseksi
                tarvittavat yhteystiedot.
              </P>
              <P>
                Jos oikaisuvaatimuspäätös voidaan antaa tiedoksi sähköisenä
                viestinä, yhteystietona pyydetään ilmoittamaan myös
                sähköpostiosoite.
              </P>
              <P>
                Jos oikaisuvaatimuksen tekijän puhevaltaa käyttää hänen laillinen
                edustajansa tai asiamiehensä tai jos oikaisuvaatimuksen laatijana on
                joku muu henkilö, oikaisuvaatimuksessa on ilmoitettava myös tämän
                nimi ja kotikunta.
              </P>
              <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
              <ul>
                <li>
                  päätös, johon haetaan oikaisua, alkuperäisenä tai jäljennöksenä
                </li>
                <li>
                  todistus siitä, minä päivänä päätös on annettu tiedoksi, tai muu
                  selvitys oikaisuvaatimusajan alkamisen ajankohdasta
                </li>
                <li>
                  asiakirjat, joihin oikaisuvaatimuksen tekijä vetoaa
                  oikaisuvaatimuksensa tueksi, jollei niitä ole jo aikaisemmin
                  toimitettu viranomaiselle.
                </li>
              </ul>
            </>
          )
        },
        assistanceDecisions: {
          decision: {
            appealInstructions: (
              <>
                <H3>Oikaisuvaatimusoikeus</H3>
                <P>
                  Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai
                  jonka oikeuteen, velvollisuuteen tai etuun päätös välittömästi
                  vaikuttaa (asianosainen).
                </P>
                <H3>Oikaisuvaatimusaika</H3>
                <P>
                  Oikaisuvaatimus on tehtävä 30 päivän kuluessa päätöksen
                  tiedoksisaannista.
                </P>
                <H3>Tiedoksisaanti</H3>
                <P>
                  Asianosaisen katsotaan saaneen päätöksestä tiedon, jollei muuta
                  näytetä, seitsemän päivän kuluttua kirjeen lähettämisestä tai
                  saantitodistukseen tai tiedoksiantotodistukseen merkittynä
                  päivänä. Käytettäessä tavallista sähköistä tiedoksiantoa
                  asianosaisen katsotaan saaneen päätöksestä tiedon, jollei muuta
                  näytetä kolmantena päivänä viestin lähettämisestä.
                  Tiedoksisaantipäivää ei lueta määräaikaan. Jos määräajan viimeinen
                  päivä on pyhäpäivä, itsenäisyyspäivä, vapunpäivä, joulu- tai
                  juhannusaatto tai arkilauantai, saa tehtävän toimittaa
                  ensimmäisenä arkipäivänä sen jälkeen.
                </P>
                <H3>Oikaisuviranomainen</H3>
                <P>Oikaisu tehdään Pohjois-Suomen aluehallintovirastolle.</P>
                <P>
                  <a href='https://www.suomi.fi/palvelut/verkkoasiointi/oikaisuvaatimus-varhaiskasvatus-opetus-ja-koulutus-aluehallintovirasto/d7022cad-9ecd-4dad-84ec-17489d260a8d'>verkkoasiointi</a>
                  <br />
                  Pohjois-Suomen aluehallintovirasto
                  <br />
                  Käyntiosoite: Linnankatu 3, Oulu
                  <br />
                  Virastoaika: ma-pe 8.00–16.15
                  <br />
                  Postiosoite: PL 6, 13035 AVI
                  <br />
                  Sähköposti: kirjaamo.pohjois@avi.fi
                  <br />
                  Fax: 0295 016 661
                  <br />
                  Puhelin: 0295 016 000
                </P>
                <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
                <P>
                  Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja
                  täyttää vaatimuksen kirjallisesta muodosta.
                </P>
                <P noMargin>Oikaisuvaatimuksessa on ilmoitettava</P>
                <ul>
                  <li>
                    Oikaisuvaatimuksen tekijän nimi, kotikunta, postiosoite,
                    puhelinnumero ja muut asian hoitamiseksi tarvittavat
                    yhteystiedot
                  </li>
                  <li>päätös, johon haetaan oikaisua</li>
                  <li>
                    miltä osin päätökseen haetaan oikaisua ja mitä oikaisua siihen
                    vaaditaan tehtäväksi
                  </li>
                  <li>vaatimuksen perusteet</li>
                </ul>
                <P>
                  Jos oikaisuvaatimuspäätös voidaan antaa tiedoksi sähköisenä
                  viestinä, yhteystietona pyydetään ilmoittamaan myös
                  sähköpostiosoite.
                </P>
                <P>
                  Jos oikaisuvaatimuksen tekijän puhevaltaa käyttää hänen laillinen
                  edustajansa tai asiamiehensä tai jos oikaisuvaatimuksen laatijana
                  on joku muu henkilö, oikaisuvaatimuksessa on ilmoitettava myös
                  tämän nimi ja kotikunta.
                </P>
                <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
                <ul>
                  <li>
                    päätös, johon haetaan oikaisua, alkuperäisenä tai jäljennöksenä
                  </li>
                  <li>
                    todistus siitä, minä päivänä päätös on annettu tiedoksi, tai muu
                    selvitys oikaisuvaatimusajan alkamisen ajankohdasta
                  </li>
                  <li>
                    asiakirjat, joihin oikaisuvaatimuksen tekijä vetoaa
                    oikaisuvaatimuksensa tueksi, jollei niitä ole jo aikaisemmin
                    toimitettu viranomaiselle.
                  </li>
                </ul>
                <H3>Oikaisuvaatimuksen toimittaminen</H3>
                <P>
                  Oikaisuvaatimuskirjelmä on toimitettava oikaisuvaatimusajan
                  kuluessa oikaisuvaatimusviranomaiselle. Oikaisuvaatimuskirjelmän
                  tulee olla perillä oikaisuvaatimusajan viimeisenä päivänä ennen
                  viraston aukiolon päättymistä. Oikaisuvaatimuksen lähettäminen
                  postitse tai sähköisesti tapahtuu lähettäjän omalla vastuulla.
                </P>
              </>
            )
          }
        }
      },
      income: {
        view: {
          incomesRegister:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan Kelasta',
          checkupConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
        },
        entrepreneurIncome: {
          checkupConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
        },
        description: (
          <>
            <P>
              Tällä sivulla voit lähettää selvitykset varhaiskasvatusmaksuun
              vaikuttavista omista ja lastesi tuloista. Voit myös tarkastella
              palauttamiasi tuloselvityksiä ja muokata tai poistaa niitä, kunnes
              viranomainen on käsitellyt tiedot. Lomakkeen käsittelyn jälkeen voit
              päivittää tulotietojasi toimittamalla uuden lomakkeen.
            </P>
            <P>
              Alle kouluikäisen varhaiskasvatus on maksutonta paltamolaisille perheille.
              Koululaisten vuorovarhaiskasvatus on maksullista.
            </P>
            <P>
              Lisätietoja maksuista:{' '}
              <a href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html">
                Maksut varhaiskasvatuksessa
              </a>
            </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              <strong>Varhaiskasvatuksen asiakasmaksu</strong> on kiinteä kuukausimaksu,
              joka määräytyy perheen tulojen ja perheenjäsenten lukumäärän mukaan.
              Maksua määrättäessä perheeksi katsotaan yhteistaloudessa avioliitossa
              tai avioliitonomaisissa olosuhteissa elävät henkilöt sekä molempien
              samassa taloudessa asuvat alaikäiset lapset. Alle kouluikäisen varhaiskasvatus
              on maksutonta paltamolaisille perheille.
            </P>
            <P>
            Lisätietoa asiakasmaksuista:{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
              >
                tästä
              </a>
              .
            </P>
            <P>* Tähdellä merkityt tiedot ovat pakollisia</P>
          </>
        ),
      },
      accessibilityStatement: (
        <>
          <H1>Saavutettavuusseloste</H1>
          <P>
            Tämä saavutettavuusseloste koskee Paltamon kunnan varhaiskasvatuksen
            eVaka-verkkopalvelua osoitteessa{' '}
            <a href="https://varhaiskasvatus.paltamo.fi">varhaiskasvatus.Paltamo.fi</a>.
            Paltamon kunta pyrkii takaamaan verkkopalvelun saavutettavuuden,
            parantamaan käyttäjäkokemusta jatkuvasti ja soveltamaan asianmukaisia
            saavutettavuusstandardeja.
          </P>
          <P>
            Palvelun saavutettavuuden on arvioinut palvelun kehitystiimi, ja seloste
            on laadittu 12.4.2022.
          </P>
          <H2>Palvelun vaatimustenmukaisuus</H2>
          <P>
            Verkkopalvelu täyttää lain asettamat kriittiset
            saavutettavuusvaatimukset WCAG v2.1 -tason AA mukaisesti. Palvelu ei ole
            vielä kaikilta osin vaatimusten mukainen.
          </P>
          <H2>Toimet saavutettavuuden tukemiseksi</H2>
          <P>
            Verkkopalvelun saavutettavuus varmistetaan muun muassa seuraavilla
            toimenpiteillä:
          </P>
          <ul>
            <li>
              Saavutettavuus huomioidaan alusta lähtien suunnitteluvaiheessa, mm.
              valitsemalla palvelun värit ja kirjaisinten koot saavutettavasti.
            </li>
            <li>
              Palvelun elementit on määritelty semantiikaltaan johdonmukaisesti.
            </li>
            <li>Palvelua testataan jatkuvasti ruudunlukijalla.</li>
            <li>
              Erilaiset käyttäjät testaavat palvelua ja antavat saavutettavuudesta
              palautetta.
            </li>
            <li>
              Sivuston saavutettavuudesta huolehditaan jatkuvalla valvonnalla
              tekniikan tai sisällön muuttuessa.
            </li>
          </ul>
          <P>
            Tätä selostetta päivitetään sivuston muutosten ja saavutettavuuden
            tarkistusten yhteydessä.
          </P>
          <H2>Tunnetut saavutettavuusongelmat</H2>
          <P>
            Käyttäjät saattavat edelleen kohdata sivustolla joitakin ongelmia.
            Seuraavassa on kuvaus tunnetuista saavutettavuusongelmista. Jos huomaat
            sivustolla ongelman, joka ei ole luettelossa, otathan meihin yhteyttä.
          </P>
          <ul>
            <li>
              Palvelun päivämäärävalitsinta ja monivalintojen alasvetovalikkoa ei
              ole optimoitu käytettäväksi ruudunlukijalla.
            </li>
            <li>
              Palvelun yksikkökartassa ei pysty liikkumaan
              näppäimistöllä/ruudunlukijalla, mutta yksikköjä voi selata samassa
              näkymässä olevalta listalta. Palvelussa käytetty kartta on kolmannen
              osapuolen tuottama.
            </li>
          </ul>
          <H2>Kolmannet osapuolet</H2>
          <P>
            Verkkopalvelussa käytetään seuraavia kolmannen osapuolen palveluita,
            joiden saavutettavuudesta emme voi vastata.
          </P>
          <ul>
            <li>Keycloak käyttäjän tunnistautumispalvelu</li>
            <li>Suomi.fi-tunnistautuminen</li>
            <li>Leaflet-karttapalvelu</li>
          </ul>
          <H2>Vaihtoehtoiset asiointitavat</H2>
          <P>
            <ExternalLink
              href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
              text="Paltamon kunnan varhaiskasvatuksen hallinto"
            />
          </P>
          <H2>Anna palautetta</H2>
          <P>
            Jos huomaat saavutettavuuspuutteen verkkopalvelussamme, kerro siitä
            meille. Voit antaa palautetta{' '}
            <ExternalLink
              href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html"
              text="verkkolomakkeella"
            />{' '}
          </P>
          <H2>Valvontaviranomainen</H2>
          <P>
            Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
            meille sivuston ylläpitäjille. Vastauksessa voi mennä 14 päivää. Jos et
            ole tyytyväinen saamaasi vastaukseen, tai et saa vastausta lainkaan
            kahden viikon aikana, voit antaa palautteen Pohjois-Suomen
            aluehallintovirastoon. Pohjois-Suomen aluehallintoviraston sivulla
            kerrotaan tarkasti, miten valituksen voi tehdä, ja miten asia
            käsitellään.
          </P>
          <P>
            <strong>Valvontaviranomaisen yhteystiedot </strong>
            <br />
            Pohjois-Suomen aluehallintovirasto <br />
            Saavutettavuuden valvonnan yksikkö
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            puhelinnumero vaihde 0295 016 000
            <br />
            Avoinna: ma-pe klo 8.00–16.15
          </P>
        </>
      ),
    },
    sv: {
      footer: {
        cityLabel: '© Paltamo kommun',
        privacyPolicyLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/tietosuoja.html"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Dataskyddsbeskrivningar
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Ge feedback
          </a>
        ),
      },
      loginPage: {
        title: 'Paltamo kommuns småbarnspedagogik',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Paltamo kommun
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "I den här vyn kan du på kartan söka enheter med småbarnspedagogik och förskola.",
      },
      applications: {
        creation: {
          transferApplicationInfo: {
            DAYCARE:
              'Barnet har redan en plats i Paltamo kommuns småbarnspedagogik. Med denna ansökan kan du ansöka om byte till en annan enhet som erbjuder småbarnspedagogik.',
          },
        },
        editor: {
          contactInfo: {
            futureAddressInfo:
              'Paltamo kommuns småbarnspedagogik betraktar adressen i befolkningsdatabasen som den officiella adressen. Adressen ändras i befolkningsregistret när du gör en flyttanmälan till posten eller magistraten.',
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Tillgänglighetsutlåtande</H1>
          <P>
            Detta tillgänglighetsutlåtande gäller Paltamo kommuns webbtjänst eVaka för
            småbarnspedagogiken på adressen{' '}
            <a href="https://varhaiskasvatus.paltamo.fi">varhaiskasvatus.paltamo.fi</a>.
            Paltamo kommun strävar efter att säkerställa webbtjänstens tillgänglighet,
            kontinuerligt förbättra användarupplevelsen och att tillämpa lämpliga
            tillgänglighetsstandarder.
          </P>
          <P>
            Tjänstens tillgänglighet har bedömts av tjänsteutvecklingsteamet, och
            utlåtandet har utarbetats den 12 april 2022.
          </P>
          <H2>Tjänstens överensstämmelse med krav</H2>
          <P>
            Webbtjänsten uppfyller de lagstadgade kritiska tillgänglighetskraven
            enligt nivå AA i WCAG 2.1. Tjänsten uppfyller ännu inte alla krav.
          </P>
          <H2>Åtgärder för att stödja tillgängligheten</H2>
          <P>
            Webbtjänstens tillgänglighet säkerställs bland annat genom följande
            åtgärder:
          </P>
          <ul>
            <li>
              Tillgängligheten beaktas redan från början i planeringsfasen till
              exempel genom att välja färgerna och fontstorleken i tjänsten med
              tillgängligheten i åtanke.
            </li>
            <li>Elementen i tjänsten har definierats semantiskt konsekvent.</li>
            <li>Tjänsten testas ständigt med en skärmläsare.</li>
            <li>
              Olika användare testar tjänsten och ger respons på tillgängligheten.
            </li>
            <li>
              Webbplatsens tillgänglighet säkerställs genom kontinuerliga kontroller
              vid tekniska eller innehållsmässiga förändringar.
            </li>
          </ul>
          <P>
            Detta utlåtande uppdateras när webbplatsen ändras eller tillgängligheten
            justeras.
          </P>
          <H2>Kända tillgänglighetsproblem</H2>
          <P>
            Användare kan fortfarande stöta på vissa problem på webbplatsen. Nedan
            följer beskrivningar av kända tillgänglighetsproblem. Om du upptäcker
            ett problem som inte finns med på listan, vänligen kontakta oss.
          </P>
          <ul>
            <li>
              Tjänstens datum- och flervalsfält är inte optimerade för att användas
              med skärmläsare
            </li>
            <li>
              Det går inte att navigera på serviceenhetskartan med
              tangentbordet/skärmläsaren, men man kan bläddra bland enheterna på
              listan i samma vy. Kartan som används i tjänsten är framtagen av en
              tredje part.
            </li>
          </ul>
          <H2>Tredje parter</H2>
          <P>
            Webbtjänsten använder följande tredjepartstjänster, vars tillgänglighet
            vi inte är ansvariga för.
          </P>
          <ul>
            <li>Användarautentiseringstjänsten Keycloak</li>
            <li>Tjänsten suomi.fi</li>
            <li>Karttjänsten Leaflet</li>
          </ul>
          <H2>Alternativa sätt att sköta ärenden</H2>
          <P>
            <ExternalLink
              href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
              text="Paltamo kommuns servicepunkter"
            />{' '}
            hjälper till med användningen av e-tjänsterna. Rådgivarna vid
            servicepunkterna hjälper de användare, för vilka de digitala tjänsterna
            inte är tillgängliga.
          </P>
          <H2>Ge respons</H2>
          <P>
            er en tillgänglighetsbrist i vår webbtjänst, vänligen meddela oss. Du
            kan ge respons med{' '}
            <ExternalLink
              href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html "
              text="webformuläret"
            />{' '}
            eller via e-post{' '}
            <a href="mailto:saavutettavuus@Paltamo.fi">saavutettavuus@Paltamo.fi</a>.
          </P>
          <H2>Tillsynsmyndighet</H2>
          <P>
            Om du upptäcker tillgänglighetsproblem på webbplatsen, ge först respons
            till oss, webbplatsens administratörer. Det kan ta upp till 14 dagar
            tills du får ett svar från oss. Om du inte är nöjd med det svar du har
            fått eller om du inte alls har fått något svar inom två veckor, kan du
            ge respons till Regionförvaltningsverket i Södra Finland. På
            regionförvaltningsverkets webbplats finns information om hur du kan
            lämna in ett klagomål samt om hur ärendet handläggs.
          </P>
          <P>
            <strong>Kontaktuppgifter till tillsynsmyndigheten</strong>
            <br />
            Regionförvaltningsverket i Södra Finland
            <br />
            Enheten för tillgänglighetstillsyn
            <br />
            <ExternalLink
              href="https://www.tillganglighetskrav.fi"
              text="www.tillganglighetskrav.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            telefonnummer till växeln 0295 016 000
            <br />
            Öppet mån.– fre. kl. 8.00–16.15
          </P>
        </>
      ),
    },
    en: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© Municipality of Paltamo',
        privacyPolicyLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/tietosuoja.html"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Privacy notices
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Give feedback
          </a>
        ),
      },
      loginPage: {
        title: 'Municipality of Paltamo early childhood education',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Paltamon kunta
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "In this view, you can search the map for Paltamo's early childhood education, pre-primary education and club places.",
      },
      applications: {
        creation: {
          preschoolInfo:
            'Pre-school education ( 4h/day ) is free of charge, on top of this you can apply for extended preschool education.',
          transferApplicationInfo: {
            DAYCARE:
              "Your child already has a place in the Municipality of Paltamos's early childhood education. Use this application to apply for a transfer to another early childhood education unit.",
          },
          applicationInfo: (
            <P>
              As long as the application has not been accepted,
              you can make changes to the application. After that,
              changes to the application are made by contacting
              the language and culture coordinator for early childhood education and care.
            </P>
          )
        },
        editor: {
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    You can apply for early childhood education all year round. The
                    application must be submitted at the latest four months before
                    the need for early childhood education begins. If you urgently
                    need early childhood education, you must apply for a place at
                    the latest two weeks before the need begins.
                  </P>
                  <P>
                    The applicant will receive a written decision on the early
                    childhood education place via the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Messages service of Suomi.fi
                    </a>{' '}
                    or by post if the applicant has not taken in use the Messages
                    service of Suomi.fi.
                  </P>
                  <P>
                    The client fees for municipal early childhood education and the
                    client charges for service voucher users are calculated as a
                    percentage of the family’s gross income. The fees vary depending
                    on the family’s size and the hours of early childhood education.
                    Service voucher units may charge an additional monthly fee,
                    information of the possible additional fee can be found from
                    units own website. Each family must provide information about
                    their gross income, no later than two weeks after their child’s
                    early childhood education has started.
                  </P>
                  <P>
                    In Paltamo the education is free of charge. For more information click here:
                    <a href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html">
                    early childhood education and care fees
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Pre-school education is attended in the year before compulsory education. {' '}
                  Pre-school education is free of charge. For more information: {' '}
                  <a href='https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html'>
                  https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html</a>
                  </P>
                  <P>
                    The decisions will be sent to the{' '}
                    <a
                    href="https://www.suomi.fi/messages"
                    target="_blank"
                    rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                      service or by post, if the applicant does not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service.
                  </P>
                  <P fitted={true}>* Information marked with a star is required</P>
                </>
              ),
              CLUB: (
                <>
                  <P>
                    The application period for clubs that start in the autumn is in March.
                    If your child is given a place in a club, you will receive a decision in April or May.
                    The decision will cover one operating period (from August until the end of May).
                    The decision will be sent to the Suomi.fi service or by post if you have not activated the service.
                  </P>
                  <P>
                    You can also submit a club application outside of the application period and after the clubs'
                    operating period has started. We will, however, first process all applications that are submitted
                    during the application period. The applications that are submitted outside of the application period
                    will be processed in the order in which they are received. The club application is for one operating period.
                    At the end of the period, the application will be removed from the system.
                  </P>
                  <P>
                    Club activities are free of charge and participation in club activities will not affect the child home care allowance
                    paid by Kela. However, if the child has been granted a place in early childhood education or your family has been
                    granted private daycare allowance, a place in a club cannot be granted to the child
                  </P>
                  <P fitted={true}>* Information marked with an asterisk is required</P>
                </>
              )
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                I understand that the application will also be visible to the other
                guardian. If the other guardian should not be able to see this
                application, please contact the Early Childhood Education Service
                Guidance, contact (tel. 040 750 5607) or by email anna.sivonen@paltamo.fi
              </span>
            ),
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                  <>
                    <P>
                      Pre-school education is attended in the year before compulsory education starts.
                      Pre-school education is free of charge. For more information:{' '}
                      <a href='https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html'>https://www.paltamo.fi/varhaiskasvatus-ja-opetus/esiopetus.html</a>

                    </P>
                  </> as unknown as string
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    If the need for a place in early childhood education arises from
                    sudden employment or a sudden start of studies, you will need to
                    apply for a place no later than{' '}
                    <strong>two weeks before</strong> your child needs it. In
                    addition to the application, you will need to{' '}
                    <strong>
                      provide documents as proof of the employment or student status
                    </strong>{' '}
                    of both guardians living in the same household.
                    If you cannot add attachments to the application electronically,
                    please send them by post to Paltamon kunta/Varhaiskasvatus,
                    Markkinatie 1, 88600 Paltamo.
                  </P>
                ),
              }
            },
            dailyTime: {
              instructions: {
                PRESCHOOL:
                  'Preschool is offered 4 hour a day, in Kontiomäki 8-12 and Kirkonkylä 8.45-12.45. Inform the early childhood education time needed by the child so that it includes the 4 hours of preschool (e.g. 7.00 – 17.00). The time will be specified when early childhood education starts. If the need for early childhood education varies daily or weekly (e.g. shift care), specify the need more precisely in the additional information at the end of the form.'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    If necessary, you can apply for additional early childhood education
                    for your child in addition to pre-school education, which is subject to a fee.
                    Additional early childhood education is provided in the mornings before pre-school
                    and after pre-school according to the opening hours of the day-care center.
                  </P>
                  <P>
                    A separate written decision will be issued on the early
                    childhood education place. The decision will be sent to the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service or by post if you do not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                You can find further information about early childhood education
                fees here, in Paltamo it is free of charge for families.
                <br />
                <a
                  href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Early childhood education fees
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Paltamo's early childhood education considers the address retrieved from the Population Register Centre as the official address. The address in the Population Register Centre changes when the applicant makes a notification of move to Posti or the Local Register Office.",
          },
        },
      },
      income: {
        description: (
          <>
           <P>
             On this page, you can submit statements on your and your
             children&apos;s earnings that affect the early childhood education
             fee. You can also view, edit, or delete income statements that you
             have submitted until the authority has processed the information.
             After the form has been processed, you can update your income
             information by submitting a new form.
           </P>
           <P>
             The client fees for municipal early childhood education are determined
             as a percentage of the family’s gross income. The fees vary according
             to family size, income and time in early childhood education.
             For the purposes of determining the fee,
             the family's informations of incomes must be submitted within two weeks
             of the start of the early childhood education and care.
             If the family fails to provide income information, the maximum fee will be imposed.
           </P>
           <P>
             More information on the fees:{' '}
             <a href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html">
               Early childhood education fees
             </a>
           </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              The early childhood education and care fee is a fixed monthly fee based on
              the family's income and the number of family members.
              For the purpose of determining the fee, a family is defined as persons living
              in a common household in a married or unmarried state, and minor children of
              both persons living in the same household.
            </P>
            <P>
              For more information on the fees: {' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.paltamo.fi/varhaiskasvatus-ja-opetus/varhaiskasvatus.html"
              >
                here
              </a>
              .
            </P>
            <P>* The information denoted with an asterisk is mandatory.</P>

          </>
        ),
        assure: <>I confirm that the information I have provided is correct. *</>,
      },
      accessibilityStatement: (
        <>
          <H1>Accessibility statement</H1>
          <P>
            This accessibility statement applies to the Municipality of Paltamo's early
            childhood education online service eVaka at{' '}
            <a href="https://varhaiskasvatus.Paltamo.fi">varhaiskasvatus.Paltamo.fi</a>.
            The Municipality of Paltamo endeavours to ensure the accessibility of the online
            service, continuously improve the user experience and apply appropriate
            accessibility standards.
          </P>
          <P>
            The accessibility of the service was assessed by the development team of
            the service, and this statement was drawn up on 12 April 2022.
          </P>
          <H2>Compliance of the service</H2>
          <P>
            The online service complies with the statutory critical accessibility
            requirements in accordance with Level AA of the Accessibility Guidelines
            for the WCAG v2.1. The service is not yet fully compliant with the
            requirements.
          </P>
          <H2>Measures to support accessibility</H2>
          <P>
            The accessibility of the online service is ensured, among other things,
            by the following measures:
          </P>
          <ul>
            <li>
              Accessibility has been taken into account from the beginning of the
              design phase, for example, when choosing the colours and font sizes of
              the service.
            </li>
            <li>
              The service elements have been defined in consistently in terms of
              semantics.
            </li>
            <li>The service is continuously tested with a screen reader.</li>
            <li>
              Various users test the service and give feedback on its accessibility.
            </li>
            <li>
              When website technology or content changes, its accessibility is
              ensured through constant monitoring.
            </li>
          </ul>
          <P>
            This statement will be updated in conjunction with website changes and
            accessibility evaluations.
          </P>
          <H2>Known accessibility issues</H2>
          <P>
            Users may still encounter some issues on the website. The following
            contains a description of known accessibility issues. If you notice an
            issue on the site that is not listed, please contact us.
          </P>
          <ul>
            <li>
              Date pickers and multi-select dropdowns in the service are not
              optimised to be used with a screen reader.
            </li>
            <li>
              The service's unit map cannot be navigated using the keyboard/screen
              reader, but the units can be browsed on the list available in the same
              view. The map used in the service is produced by a third party.
            </li>
          </ul>
          <H2>Third parties</H2>
          <P>
            The online service uses the following third party services, the
            accessibility of which we cannot be responsible for.
          </P>
          <ul>
            <li>Keycloak user identification service</li>
            <li>Suomi.fi identification</li>
            <li>Leaflet map service</li>
          </ul>
          <H2>Alternative ways of accessing the service</H2>
          <P>
            <ExternalLink
              href="https://www.Paltamo.fi/en/administration/service/"
              text="The municipality of Paltamo's Service Point"
            />{' '}
            provide assistance with using electronic services. Service advisors at
            the Service Points help users who cannot access digital services.
          </P>
          <H2>Give feedback</H2>
          <P>
            If you notice an accessibility gap in our online service, please let us
            know! You can give us feedback using the{' '}
            <ExternalLink
              href="https://www.paltamo.fi/kunta-ja-hallinto/palaute.html"
              text="online form"
            />{' '}
            or by emailing{' '}
            <a href="mailto:saavutettavuus@Paltamo.fi"> saavutettavuus@Paltamo.fi</a>.
          </P>
          <H2>Supervisory authority</H2>
          <P>
            If you notice any accessibility issues on the website, please send us,
            the site administrator, feedback first. It may take us up to 14 days to
            reply. If you are not satisfied with the reply or you do not receive a
            reply within two weeks, you can give feedback to the Regional State
            Administrative Agency for Southern Finland. The website of the Regional
            State Administrative Agency for Southern Finland explains in detail how
            a complaint can be submitted, and how the matter will be processed.
          </P>
          <P>
            <strong>Contact information of the supervisory authority</strong>
            <br />
            Regional State Administrative Agency of Southern Finland
            <br />
            Accessibility Supervision Unit
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            tel. (exchange) 0295 016 000
            <br />
            Open: Mon-Fri 8.00–16.15
          </P>
        </>
      ),
    },
  },
  cityLogo: {
    src: MunicipalityLogo,
    alt: 'Paltamo logo',
  },
  routeLinkRootUrl: 'https://reittiopas.hsl.fi/reitti/',
  mapConfig,
  featureFlags,
  getMaxPreferredUnits() {
    return 3
  },
}

export default customizations
